import * as React from "react";
const EthicallySourcedSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="M35.45 28c2.697-3.785 4.071-7.698 2.16-9.61-1.912-1.912-5.825-.537-9.61 2.16-3.786-2.697-7.698-4.072-9.61-2.16-1.912 1.912-.537 5.825 2.16 9.61-2.697 3.786-4.072 7.698-2.16 9.61.616.616 1.438.89 2.397.89 2.02 0 4.646-1.222 7.218-3.05 2.562 1.828 5.187 3.05 7.214 3.05.958 0 1.781-.276 2.396-.89 1.906-1.912.532-5.824-2.165-9.61Zm.922-8.373c.836.836.272 3.544-2.025 6.922-.727-.9-1.5-1.76-2.318-2.578a32.833 32.833 0 0 0-2.578-2.315c3.378-2.296 6.086-2.865 6.922-2.029ZM33.282 28a31.632 31.632 0 0 1-2.49 2.792A31.631 31.631 0 0 1 28 33.282a31.63 31.63 0 0 1-2.793-2.49A31.616 31.616 0 0 1 22.718 28 32.662 32.662 0 0 1 28 22.718a31.63 31.63 0 0 1 2.792 2.49c.884.88 1.716 1.813 2.49 2.792Zm-13.655-8.373c.24-.241.638-.366 1.162-.366 1.293 0 3.356.755 5.758 2.395a33.26 33.26 0 0 0-2.576 2.315 32.833 32.833 0 0 0-2.315 2.578c-2.297-3.378-2.864-6.086-2.029-6.922Zm0 16.746c-.835-.836-.268-3.544 2.03-6.921.726.899 1.5 1.76 2.317 2.577a33.268 33.268 0 0 0 2.574 2.315c-3.377 2.297-6.085 2.865-6.92 2.029Zm16.746 0c-.836.837-3.544.271-6.922-2.026.9-.727 1.76-1.5 2.578-2.318a32.87 32.87 0 0 0 2.315-2.578c2.297 3.378 2.864 6.086 2.029 6.922ZM29.313 28a1.312 1.312 0 1 1-2.625 0 1.312 1.312 0 0 1 2.624 0Z"
    />
  </svg>
);
export default EthicallySourcedSVG;
